/* OREVYN UX 2026-10-07: faster mobile purchase path.
   1. Variant pills: a value is selectable whenever any available variant has it. Picking it switches the other options to the closest available
      combination, instead of leaving the buyer on a disabled "הגרסה אינה זמינה" button (ÉCLIPSE 4 מ"מ could not be selected at all).
      Values with no available variant are hidden instead of shown crossed out.
   2. The add-to-cart button shows the price, so the sticky bar answers "how much" before the title scrolls into view. */
(() => {
  const section = document.querySelector('[data-product-section]');
  if (!section) return;
  const select = section.querySelector('[data-variant-select]');
  const groups = [...section.querySelectorAll('.product-option')];
  const button = section.querySelector('[data-add-button]');
  const addLabel = section.querySelector('[data-add-label]');
  const priceValue = section.querySelector('[data-product-price-value]');

  const priceInButton = () => {
    if (!addLabel || !button || button.disabled || !priceValue) return;
    const price = priceValue.textContent.trim();
    addLabel.textContent = price ? 'הוספה לסל · ' + price : 'הוספה לסל';
  };

  if (select && groups.length) {
    const available = [...select.options].map(option => {
      try { return { values: JSON.parse(option.dataset.options), available: !option.disabled }; }
      catch (_) { return null; }
    }).filter(v => v && v.available);
    const radiosOf = group => [...group.querySelectorAll('input[type="radio"]')];
    const current = () => groups.map(group => group.querySelector('input:checked')?.value ?? '');

    const refresh = () => {
      groups.forEach((group, index) => {
        radiosOf(group).forEach(radio => {
          const possible = available.some(v => v.values[index] === radio.value);
          const pill = radio.closest('.option-pill');
          radio.disabled = !possible;
          if (pill) {
            pill.classList.remove('is-unavailable');
            pill.hidden = !possible;
          }
        });
      });
    };

    const correct = changedIndex => {
      const chosen = current();
      if (!available.length || available.some(v => v.values.every((value, i) => value === chosen[i]))) return;
      let best = null;
      let bestScore = -1;
      available.forEach(v => {
        if (v.values[changedIndex] !== chosen[changedIndex]) return;
        const score = v.values.filter((value, i) => value === chosen[i]).length;
        if (score > bestScore) { best = v; bestScore = score; }
      });
      if (!best) best = available[0];
      let last = null;
      best.values.forEach((value, i) => {
        const radio = groups[i] && radiosOf(groups[i]).find(r => r.value === value);
        if (radio && !radio.checked) { radio.disabled = false; radio.checked = true; last = radio; }
      });
      /* let the theme's own handler update the price, label and hidden variant select */
      if (last) last.dispatchEvent(new Event('change', { bubbles: true }));
    };

    groups.forEach((group, index) => group.addEventListener('change', () => {
      correct(index);
      refresh();
      priceInButton();
    }));
    refresh();
  }
  priceInButton();
})();
